import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import {
  CertNumberRequestSpace,
  CertNumberVerifySpace,
  KTMVNOVerifySpace,
  VulnerableVerifySpace,
  ResponseDataType,
  SKTBillLetterJoinSpace,
  SKTBillLetterOtpVerifySpace,
} from 'src/types/api'
import { AxiosError } from 'axios'
import { fetch } from 'src/service/api/fetcher'
import { CMDTYPES } from 'src/types/cmdtype'

export function useCustomMutation<T, U>(
  option: UseMutationOptions<ResponseDataType<U>, AxiosError, T>,
): UseMutationResult<ResponseDataType<U>, AxiosError, T, unknown> {
  return useMutation(option)
}

export const certRequestQuery = (): UseMutationOptions<
  ResponseDataType<CertNumberRequestSpace.Response>,
  AxiosError,
  CertNumberRequestSpace.Request
> => ({
  mutationKey: ['certRequestQuery'],
  mutationFn: async (data: CertNumberRequestSpace.Request) =>
    fetch.post<CertNumberRequestSpace.Request, CertNumberRequestSpace.Response>(
      CMDTYPES.OTP_REQUEST_API,
      data,
    ),
})

export const certVerifyQuery = (): UseMutationOptions<
  ResponseDataType<CertNumberVerifySpace.Response>,
  AxiosError,
  CertNumberVerifySpace.Request
> => ({
  mutationKey: ['certVerifyQuery'],
  mutationFn: async (data: CertNumberVerifySpace.Request) =>
    fetch.post<CertNumberVerifySpace.Request, CertNumberVerifySpace.Response>(
      CMDTYPES.OTP_VERIFY_API,
      data,
    ),
})

export const recaptchaRequestQuery = (): UseMutationOptions<
  ResponseDataType<CertNumberRequestSpace.Response>,
  AxiosError,
  CertNumberRequestSpace.Request
> => ({
  mutationKey: ['recaptchaRequestQuery'],
  mutationFn: async (data: CertNumberRequestSpace.Request) =>
    fetch.post<CertNumberRequestSpace.Request, CertNumberRequestSpace.Response>(
      CMDTYPES.RECAPTCHA_REQUEST_API,
      data,
    ),
})

export const KTMVNOVerifyQuery = (): UseMutationOptions<
  ResponseDataType<KTMVNOVerifySpace.Response>,
  AxiosError,
  KTMVNOVerifySpace.Request
> => ({
  mutationKey: ['KTMVNOVerifyQuery'],
  mutationFn: async (data: KTMVNOVerifySpace.Request) =>
    fetch.post<KTMVNOVerifySpace.Request, KTMVNOVerifySpace.Response>(
      CMDTYPES.KT_MVNO_VERIFY_API,
      data,
    ),
})

export const VulnerableVerifyQuery = (): UseMutationOptions<
  ResponseDataType<VulnerableVerifySpace.Response>,
  AxiosError,
  VulnerableVerifySpace.Request
> => ({
  mutationKey: ['VulnerableVerifyQuery'],
  mutationFn: async (data: VulnerableVerifySpace.Request) =>
    fetch.post<VulnerableVerifySpace.Request, VulnerableVerifySpace.Response>(
      CMDTYPES.VULNERABLE_VERIFY_API,
      data,
    ),
})

export const billLetterCertVerifyQuery = (): UseMutationOptions<
  ResponseDataType<SKTBillLetterOtpVerifySpace.Response>,
  AxiosError,
  SKTBillLetterOtpVerifySpace.Request
> => ({
  mutationKey: ['billLetterCertVerifyQuery'],
  mutationFn: async (data: SKTBillLetterOtpVerifySpace.Request) =>
    fetch.post<SKTBillLetterOtpVerifySpace.Request, SKTBillLetterOtpVerifySpace.Response>(
      CMDTYPES.SKT_BILL_LETTER_OTP_VERIFY_API,
      data,
    ),
})

export const billLetterJoinQuery = (): UseMutationOptions<
  ResponseDataType<SKTBillLetterJoinSpace.Response>,
  AxiosError,
  SKTBillLetterJoinSpace.Request
> => ({
  mutationKey: ['billLetterJoinQuery'],
  mutationFn: async (data: SKTBillLetterJoinSpace.Request) =>
    fetch.post<SKTBillLetterJoinSpace.Request, SKTBillLetterJoinSpace.Response>(
      CMDTYPES.SKT_BILL_LETTER_JOIN_API,
      data,
    ),
})
